import { render, staticRenderFns } from "./NavbarIconLink.vue?vue&type=template&id=47aba725&"
import script from "./NavbarIconLink.vue?vue&type=script&lang=js&"
export * from "./NavbarIconLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports